<template>
  <div>
    <div class="card-body">
      <table class="table table-sm table-bordered">
        <thead class="bg-custom">
          <tr>
            <th>Document Name</th>
            <th>Description</th>
            <th>Selected</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="doc in docData" :key="doc.BPDR_ID">
            <td>{{ doc.BPDR_DOCUMENTNAME }}</td>
            <td>{{ doc.BPDR_DESCRIPTION }}</td>
            <td>
              <input type="checkbox" v-model="doc.selected" @change="updateSelection(doc)" />
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="card-footer">
      <button type="button" v-on:click="submitForm" class="btn btn-success float-right mr-1">Submit</button>
    </div>
  </div>
</template>

<script>
  import axios from 'axios';

  export default {
    props: {
      clientid: Number,
    },
    data() {
      return {
        docData: []
      };
    },
    created() {
      this.pageLoad();
    },
    methods: {
      pageLoad() {
        var vm = this;
        axios.get("/api/UICApi/PageLoadDocumentRequired?ID=" + this.clientid)
          .then(function (res) {
            vm.docData = res.data.Documents.map(doc => ({
              ...doc,
              selected: doc.BPDR_SELECTED === 'Y' 
            }));
          })
          .catch((error) => {
            console.log(error);
            endReq();
          });
      },
      updateSelection(doc) {
        doc.BPDR_SELECTED = doc.selected ? 'Y' : 'N';
      },
      submitForm() {
        var vm = this;
        startReq();
        axios.post('/api/UICApi/SaveDocumentRequired', {
          Documents: vm.docData,
        })
          .then(response => {
            endReq();
            if (response.data.status) {
              toastr.success(response.data.msg);
            } else {
              toastr.error(response.data.msg);
            }
          })
          .catch(error => {
            endReq();
            vm.error = 'Error saving DocumentRequired';
            console.log(error);
          });
      },
    }
  };
</script>

<style scoped>
 /* table {
    width: 100%;
    border-collapse: collapse;
  }

  th, td {
    padding: 8px;
    text-align: left;
  }

  th {
    background-color: #f2f2f2;
  }*/
</style>



// WEBPACK FOOTER //
// src/components/ims/DocumentRequired.vue